// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70d4c0ee","574":"a6c6f172","805":"42d3b059"}[chunkId] + ".chunk.js";
};